import { datadogRum } from '@datadog/browser-rum';
import { HUB_URL } from '@shared/lib/constants';

let initialized = false;

function resolveEnv(): string {
  const h = window.location.hostname;
  if (h === 'localhost' || h === '127.0.0.1') return 'development';
  if (h.startsWith('dev.')) return 'dev';
  return 'production';
}

export function initDatadog() {
  if (initialized) return;

  datadogRum.init({
    applicationId: 'de3bbc7f-f690-41fa-a0e7-86896ac28468',
    clientToken: 'pubbbde9f30d5f16d60033abb9b4c7ef429',
    site: 'us5.datadoghq.com',
    service: 'dashboard-frontend',
    env: resolveEnv(),
    version: __GIT_COMMIT_HASH__,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'allow',
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    allowedTracingUrls: [HUB_URL],
    traceSampleRate: 100,
  });

  initialized = true;
}

type RumUser = {
  id: string;
  email?: string;
  name?: string;
};

export function setDatadogUser(user: RumUser | null) {
  if (!initialized) return;
  if (user) {
    datadogRum.setUser({
      id: user.id,
      email: user.email,
      name: user.name,
    });
  } else {
    datadogRum.clearUser();
  }
}
